// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"d9fee0db","57":"2cff8001","79":"c9003dd1","124":"5b1ac9cb","453":"87e45203","621":"08b7ba1c","660":"dff304d2","697":"b19c04bd","712":"60e0754e","908":"6261d4f0","971":"e9292e88","986":"9b735aac"}[chunkId] + ".chunk.js";
};